<!--

Switch component can accept multiple props to change the appearance and behaviour.

id:                 Id of the switch we want to operate. If multiple switches have the same id they will all be affected when one of them is switched.
size:               defines the size of a switch ['mini', 'mini-small', 'micro'] and extra styling ['no-label-margin']
value:              initial state
outline-color:      color of the switch outline
switch-color:       color of the switch
off-outline-color:  color of the switch outline when switch is off
off-switch-color:   color of the switch when switch is off

TODO ::: props to set exact width and height. Size can stay and can be a primary dimension prop.

-->


<template>
  <div
    :class="size"
    class="rounded-checkbox-wrapper"
    :style="cssVars">
    <div class="checkbox rounded-checkbox">
      <input
        :id="buttonID"
        v-model="checked"
        type="checkbox"
        class="rounded"
        @change="changeState">
      <label :for="buttonID"/>
    </div>
  </div>
</template>

<style scoped>
label {
  background-color: var(--outline-color)!important;
}

label::after{
  background-color: var(--switch-color)!important;
}
</style>

<script>
import SBColors from '@/helpers/lists/colors';
import randomString from '@/helpers/randomString';

export default {
  name: 'SwitchCheckbox',
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
    size: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      default: false,
    },
    outlineColor: {
      type: String,
      default: SBColors.bluePrimary,
    },
    switchColor: {
      type: String,
      default: '#ffffff',
    },
    offOutlineColor: {
      type: String,
      default: '#b1b8c4',
    },
    offSwitchColor: {
      type: String,
      default: '#ffffff',
    },
  },
  data() {
    return {
      checked: this.value,
      randomId: randomString(),
      SBColors,
    };
  },
  computed: {
    cssVars() {
      return {
        '--outline-color': this.checked ? this.outlineColor : this.offOutlineColor,
        '--switch-color': this.checked ? this.switchColor : this.offSwitchColor,
      };
    },
    buttonID() {
      return this.id ? this.id : this.randomId;
    },
  },
  watch: {
    value(value) {
      this.checked = value;
    },
  },
  methods: {
    changeState() {
      this.$emit('input', this.checked);
    },
  },
};
</script>
